import React from "react";

const Dashboard = () => {
  return (
    <div className="p-4 min-h-[50vh]">
      <h1 className="text-2xl font-bold mb-4 text-orange">Dashboard</h1>
      <nav>
        <ul className="space-y-2">
          <li>
            <a href="/admin/category" className="text-blue-500 hover:underline">
              Category management
            </a>
          </li>
          <li>
            <a href="/admin/machine" className="text-blue-500 hover:underline">
              Machine management
            </a>
          </li>
          <li>
            <a href="/admin/news" className="text-blue-500 hover:underline">
              News management
            </a>
          </li>
          <li>
            <button
              className={`text-blue-500 hover:underline`}
              onClick={() =>
                fetch("/api/auth/logout").then(() => {
                  window.location.reload();
                  localStorage.removeItem("user_id");
                })
              }
            >
              Logout
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Dashboard;
